import API, { API_URL } from "api/API";
import { ApiResult, ObsDelayStatus } from "libs/types";

interface GetForecastDevInfoApiResult extends ApiResult {
  data: {
    obs_info: ObsDelayStatus[];
    log: string[];
  }
}

async function getForecastDevInfoApi():Promise<GetForecastDevInfoApiResult> {
  const {data} = await API.get(`${API_URL.FORECAST.GET_DEV_INFO}`);

  return data;
}

export default getForecastDevInfoApi;